module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWBAMAAAA2mnEIAAAAMFBMVEVHcEz///////7///7///7///7///////7///////7//////////////////O7///+cg4rBAAAADnRSTlMAh27m2qoWuZrKVvUnOhFq8QoAAAC+SURBVBjTY2BgYGDTKG86wAAB0v////8IYXL+/95R/98NzJ7/9QADW/9nEJPxvwKQ5PpfACTzvzIwhSowyP8FsvU/MNS9e87A/APIji9gevfunQDHTyDbX4ATyHZg+ozGrg9gBLIDGL8A2fIbGPzePU5g+Qpk3//FwGHcBqKATvgNtt3eAEjw/A8A274AJCL/CUis/wp1pwLQOQYQR9t/Ylj/OwHCTvkv9H8P1F9s8/9/gfmRgeN/GQMcKIJJAKRbSA2Ixt+vAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/funding_jolin/home/icon-location.png
// module id = +oXh
// module chunks = 1